<template>
  <div>
    <v-data-table
      :show-expand="true"
      :headers="headers"
      :items="filteredOrder"
      :loading="loading"
      item-key="uid"
      no-data-text="Quick Search only works for the latest 1000 Orders! If you can't find an order please use specific search (Click arrow next to Quick Search)"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 75],
      }"
    >
      <template v-slot:item.orderName="{ item }">
        <v-icon v-if="item.showOrderWarning" color="warning">mdi-alert</v-icon>
        <a class="orderLink" @click="() => openOrder(item.uid)">
          {{ item.orderName }}
          <v-icon small class="orderLink__icon">mdi-open-in-new</v-icon>
        </a>
      </template>
      <template v-slot:item.orderStatus="{ item }">
        <span class="tblStatus" :class="'tblStatus--' + (item.status || '').toLowerCase()">
          {{ item.status }}
        </span>
      </template>
      <template v-slot:item.orderDate="{ item }">
        {{ getOrderDateFromNow(item.orderDate) }}
      </template>
      <template v-slot:item.name="{ item }">
        {{
          item.shippingAddress.firstName + " " + item.shippingAddress.lastName
        }}
      </template>
      <template v-slot:item.numberOfTasks="{ item }">
        {{ item.tasks.length }}
      </template>
      <template v-slot:expanded-item="{ item }">
        <td class="expanded-item-cell" :colspan="headers.length">
          <OrderTasks :order-tasks="item.tasks" />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import OrderTasks from "@/components/AllOrders/components/OrderTasks";
import {getDateFromNow, openOrderModal} from "@/utils";
import { mapGetters } from "vuex";

export default {
  name: "OrdersTable",
  components: { OrderTasks },
  data() {
    return {
      headers: [
        { text: "Order Name", value: "orderName" },
        { text: "Order Status", value: "orderStatus" },
        { text: "Order Date", value: "orderDate" },
        { text: "Name", value: "name" },
        { text: "Number of Tasks", value: "numberOfTasks" },
      ],
    };
  },
  props: {
    orders: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["filterQuickSearch"]),
    filteredOrder() {
      return this.orders.filter((item) => {
        // Perform the search on the relevant fields
        const name =
          item.shippingAddress.firstName + " " + item.shippingAddress.lastName;
        const searchText = this.filterQuickSearch.toLowerCase();

        // Return true if any relevant field matches the search query
        return (
          item.orderName.toLowerCase().includes(searchText) ||
          item.status.toLowerCase().includes(searchText) ||
          name.toLowerCase().includes(searchText) ||
          item.tasks.length.toString().includes(searchText) ||
          item?.shippingAddress?.addressPrimary
            ?.toLowerCase()
            .includes(searchText) ||
          item.status.toLowerCase().includes(searchText) ||
          item.uid.toString().includes(searchText) ||
          item.customer?.email?.toLowerCase().includes(searchText) ||
          item.customer?.name?.toLowerCase().includes(searchText)
        );
      });
    },
  },
  methods: {
    openOrder(uid) {
      openOrderModal(uid)
    },
    getOrderDateFromNow(date) {
      return getDateFromNow(date);
    },
  },
};
</script>

<style lang="scss" scoped>
.expanded-item-cell {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}

/* Ordername ist DER Einstieg — als Link erkennbar machen */
.orderLink {
  color: #7b5cd6 !important;
  font-weight: 700;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  margin-left: -10px;
  border-radius: 8px;
  transition: background 0.15s;

  &__icon {
    color: #7b5cd6 !important;
    opacity: 0;
    transition: opacity 0.15s;
  }
  &:hover {
    background: rgba(123, 92, 214, 0.1);

    .orderLink__icon {
      opacity: 1;
    }
  }
}

/* Status als ruhige Pills (Farben wie im OrderView) */
.tblStatus {
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  padding: 2px 10px;
  background: #f1f0f5;
  color: rgba(0, 0, 0, 0.55);
  white-space: nowrap;

  &--ready_for_fulfill { background: #e3f2fd; color: #1565c0; }
  &--order_created, &--in_progress, &--waiting_for_fulfill { background: #fff6e8; color: #b26a00; }
  &--in_fulfill { background: #ede7f6; color: #5e35b1; }
  &--fulfilled { background: #e8f5e9; color: #2e7d32; }
  &--fulfill_error { background: #ffebee; color: #c62828; }
  &--closed { background: #f1f0f5; color: rgba(0, 0, 0, 0.5); }
}
</style>
